import { ReactComponent as DownloadIcon } from "images/downloadIcon.svg";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { observer } from "mobx-react-lite";
import { parseErrorMessage } from "utils";
import { useState } from "react";
import { CustomButton } from "ui";

import styles from "./template.module.css";

type Props = {
  tooltip?: string;
  fn: () => Promise<any>;
};

export const DownloadTemplatesFileBtn = observer(({ tooltip, fn }: Props) => {
  const [loading, setLoading] = useState(false);
  const { openNotification } = useNotificationContext();

  const handleDownloadFile = async () => {
    setLoading(true);
    try {
      await fn();
    } catch (error: any) {
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.ERROR,
        description: parseErrorMessage(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomButton
      size="small"
      type="text"
      disabled={loading}
      onClick={handleDownloadFile}
      loading={loading}
      tooltip={tooltip}
      icon={<DownloadIcon />}
      className={styles.uploadDocBtn}
    />
  );
});
